import React, { useEffect } from "react";
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import lozad from 'lozad';
import { videoTagString ,VideoTag } from "react-video-tag";
// import { Player, PosterImage } from 'video-react';

import logo from "/assets/images/2022aug/logo.svg";
import textNew from "/assets/images/2022aug/new.svg";
import textColor from "/assets/images/2022aug/color.svg";
import textDebut from "/assets/images/2022aug/debut.svg";
import release from "/assets/images/2022aug/online_release.svg";
import lineup from "/assets/images/2022aug/lineup.png";
import arrow from "/assets/images/2022aug/arrow01.svg";
import video from "/assets/images/2022aug/movie.mp4";
import poster from "/assets/images/2022aug/dummy.jpg";
import '../styles/Firstview.scss'

const Firstview = () => {

    // 動画のコンポーネント作成
    videoTagString({ src: video, poster: poster })
    const FvVideo = () => {
        return (
            <VideoTag src={video} poster={poster} muted autoPlay playsInline loop/>
        )
    }

    gsap.registerPlugin(ScrollTrigger);

    useEffect(() => {


        //遅延読み込み
        const observer = lozad(); 
        observer.observe();

        // 100vh調整
        // const setHeight = () => {
        //     let vh = window.innerHeight * 0.01;
        //     document.documentElement.style.setProperty('--vh', `${vh}px`)
        // }
        // setHeight();

        const setCenter = () => {
            const obj = document.querySelector('.fv__container');
            const objH = obj.clientHeight;
            const objW = obj.clientWidth;
            const win = window;
            const winH = window.innerHeight;
            const winW = window.innerWidth;
            obj.style.top = ((winH - objH) / 2) + "px";
        }
        if (window.innerWidth >= 1440) {
            setCenter();
            window.addEventListener('resize', setCenter);
        }
              
        //文字表示
        const showText = () => {
            const text = document.getElementsByClassName('wrap-inner');
            gsap.set(text, {
                y: 100,
                opacity: 0,
            });
            gsap.to(text, {
                // delay: 1,
                duration: 1.2,
                y: 0,
                opacity: 1,
                ease: "power2.out",
                stagger: {
                  amount: 0.8    
                }
            });
        }
        showText();
        // window.addEventListener('load', showText);

        // サークル回転
        const circle = document.getElementsByClassName('circle');
        gsap.to(circle, {
            rotation: 360,
            ease: "none",
            repeat: -1,
            transformOrigin: "center",
            duration: 5
        });
        
        //固定アニメーション
        const layer = document.getElementsByClassName('layer');
        const target = document.getElementsByClassName('scrollable');
        const targets = Array.prototype.slice.call(target);
        const winH = window.innerHeight;
        const adjuster = winH / 5;
        console.log(adjuster);

        gsap.set(layer, {
            autoAlpha: 0.4
        });
        gsap.to(layer, {
            autoAlpha: 0,
            scrollTrigger: {
                trigger: '.fv',
                pin: true,
                scrub: true,
                start: 'top top',
                end: `bottom top-=${adjuster}`,
                pinSpacing: true,
                toggleActions: 'play none none reverse',
                normalizeScroll: true,
                ignoreMobileResize: true
            }
        });
        gsap.to(targets, {
            y: `-=${winH}`,
            scrollTrigger: {
                trigger: '.fv',
                pin: true,
                scrub: 1,
                start: 'top top',
                end: `bottom top-=${adjuster}`,
                pinSpacing: true,
                toggleActions: 'play none none reverse',
                normalizeScroll: true,
                ignoreMobileResize: true
            }
        });
        
    }, []);


    return (
        <section className="fv" id="pageTop">
            <div className="layer"></div>
            <div className="fv__inner">

                <div className="fv__logo scrollable">
                    <a href="https://uchoobeauty.com/"><img src={logo} alt="U/CHOO" /></a>
                </div>

                <div className="fv__container">
                    <h1 className="fv__title">
                        <div className="new wrap">
                            <div className="wrap-inner"><img src={textNew} alt="NEW" /></div>
                        </div>
                        <div className="color wrap">
                            <div className="wrap-inner"><img src={textColor} alt="COLOR" /></div>
                        </div>
                        <div className="debut wrap">
                            <div className="wrap-inner"><img src={textDebut} alt="DEBUT" /></div>
                        </div>
                    </h1>

                    <div className="fv__date">
                        <div><img src={release} alt="2022.8.15 ONLINE RELEASE" /></div>
                    </div>

                    <div className="fv__lineup">
                        <div><img src={lineup} alt="PINK BELLINI / MILKY COCO / CARAmel COCO" /></div>
                    </div>

                    <div className="fv__video scrollable">
                        <div className="wrap">
                            {/* <video autoplay="" loop="" muted="" playsinline=""
                            src={video}
                            poster={dummy}>
                            </video> */}
                            <FvVideo poster={poster}/>
                            {/* <Player
                            poster={poster}
                            src={video}
                            autoPlay loop muted playsInline
                            /> */}
                        </div>
                    </div>

                    <div className="fv__scrollDown">
                        <AnchorLink href="#bellini">
                            <div className="circle"></div>
                            <div className="arrow"><img src={arrow} alt="SCROLL DOWN" /></div>
                        </AnchorLink>
                    </div>
                </div>


            </div>
        </section>
    )
}

export default Firstview